module.exports = __webpack_public_path__ + "img/img5.7f803942.png";